import React, { useState, useEffect } from 'react';
import Image1 from "../../assets/images/sars/SRAS-CoV-2_Main1.png";
import Image2 from "../../assets/images/sars/SRAS-CoV-2_Main2.png";
import Image3 from "../../assets/images/sars/SRAS-CoV-2_Main3.png";

// Example image list
const images = [Image1, Image2, Image3];

const SARSCard = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);

  // Change image every 3.5 seconds (3 seconds display + 0.5 second animation)
  useEffect(() => {
    const interval = setInterval(() => {
      // Start animation
      setIsAnimating(true);
      
      // After animation completes, update current image
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsAnimating(false);
      }, 500); // Animation duration: 0.5 seconds (faster!)
      
    }, 3500); // Total cycle: 3.5 seconds (3s display + 0.5s animation)
    
    return () => clearInterval(interval);
  }, []);

  // Update next index when current index changes
  useEffect(() => {
    setNextIndex((currentIndex + 1) % images.length);
  }, [currentIndex]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '60px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flex: '1 1 100%',
          maxWidth: '1020px',
          backgroundColor: '#fff',
          borderRadius: '10px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)';
          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
        }}
      >
        {/* Left: image carousel with animation */}
        <div style={{ 
          flex: '1 1 40%', 
          minWidth: '350px',
          position: 'relative',
          overflow: 'hidden',
          height: '300px' // Fixed height for consistency
        }}>
          {/* Current image - always visible */}
          <img
            src={images[currentIndex]}
            alt="SARS-CoV-2 Summary"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1
            }}
          />
          
          {/* Next image flying from right - only shown during animation */}
          {isAnimating && (
            <img
              src={images[nextIndex]}
              alt="SARS-CoV-2 Summary Next"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 2,
                animation: 'flyFromRight 0.5s ease-out forwards' // Faster animation (0.5s)
              }}
            />
          )}
        </div>

        {/* Right: text */}
        <div style={{ flex: '1 1 60%', padding: '30px' }}>
          <h3>SARS-CoV-2 Genomics Surveillance Portal</h3>
          <br/>
          <p style={{ lineHeight: '1.6', color: '#444' }}>
            Explore the SARS-CoV-2 genomic data analyzed for Missouri. This summary highlights variant distribution, case trends, and outbreak tracking using PathoTrack pipelines.
          </p>
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <a
              href="https://dataportals.missouri.edu/SARSCoV2"
              style={{
                display: 'inline-block',
                padding: '12px 25px',
                backgroundColor: '#007bff',
                color: '#fff',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: '500',
              }}
            >
            Explore the Portal            
            </a>
          </div>
        </div>
      </div>
      
      {/* Add keyframes for animation */}
      <style jsx>{`
        @keyframes flyFromRight {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
};

export default SARSCard;